import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { SeoGetSlug } from '../../services';

export const fetchSeoGet = createAsyncThunk(
    'seoGet/fetchSeoGet',
    async ({ slug }) => {
        if (slug === "anasayfa" || slug === "homepage") {
            var data = localStorage.getItem('seo-home')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-home', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "hakkimizda" || slug === "about-us") {
            var data = localStorage.getItem('seo-about')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-about', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "ucretler" || slug === "wages") {
            var data = localStorage.getItem('seo-wages')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-wages', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "indirme" || slug === "download") {
            var data = localStorage.getItem('seo-download')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-download', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "iletisim" || slug === "contact") {
            var data = localStorage.getItem('seo-contact')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-contact', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "sss" || slug === "faq") {
            var data = localStorage.getItem('seo-sss')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-sss', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "is-ortaklarimiz" || slug === "our-bussiness-partners") {
            var data = localStorage.getItem('seo-partners')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-partners', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "istasyonlar" || slug === "stations") {
            var data = localStorage.getItem('seo-stations')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-stations', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "mesafeli-satis-sozlesmesi" || slug === "distance-sales-agreement") {
            var data = localStorage.getItem('seo-contract1')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-contract1', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "iptal-ve-iade-kosullari" || slug === "cancellation-and-refund-conditions") {
            var data = localStorage.getItem('seo-contract2')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-contract2', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "uyelik-sozlesmesi" || slug === "membership-contract") {
            var data = localStorage.getItem('seo-contract3')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-contract3', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "gizlilik-sozlesmesi" || slug === "privacy-policy") {
            var data = localStorage.getItem('seo-contract4')
            if (data) {
                return JSON.parse(data)
            }
            const response = await SeoGetSlug(slug)
            localStorage.setItem('seo-contract4', JSON.stringify(response.result))
            return response.result
        }
        const response = await SeoGetSlug(slug)
        return response.result;
    }
);

const seoGetSlice = createSlice({
    name: 'seoGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSeoGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSeoGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSeoGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default seoGetSlice.reducer;
